import { memo } from "react";
import { ProfileTabs } from "consts/profile";
import { RoleName } from "consts/auth";
import useAuthorization from "features/auth/useAuthorization";
import StatefulTabs from "ui/widgets/StatefulTabs";
import GeneralInfo from "./GeneralInfo";
import FinancialDetails from "./FinancialDetails";
import FeesMethods from "./FeesMethods";
import TechnicalInformation from "./TechnicalInformation";
import Tab from './Tab';

const Tabs = () => {
    const { withAuthorization } = useAuthorization();

    return (
        <StatefulTabs
            onChange={() => { }}
            model={withAuthorization([
                {
                    label: ProfileTabs.GeneralInfo,
                    component: (
                        <Tab
                            title={ProfileTabs.GeneralInfo}
                        >
                            <GeneralInfo />
                        </Tab>
                    ),
                    roles: [RoleName.MerchantAdmin]
                },
                {
                    label: ProfileTabs.FinancialDetails,
                    component: (
                        <Tab
                            title={ProfileTabs.FinancialDetails}
                        >
                            <FinancialDetails />
                        </Tab>
                    ),
                    roles: [
                        RoleName.MerchantAdmin,
                        RoleName.MerchantFinance
                    ]
                },
                {
                    label: ProfileTabs.FeesMethods,
                    component: (
                        <Tab
                            sx={{
                                maxWidth: 'initial'
                            }}
                        >
                            <FeesMethods />
                        </Tab>
                    ),
                    roles: [
                        RoleName.MerchantAdmin,
                        RoleName.MerchantTech
                    ]
                },
                {
                    label: ProfileTabs.TechnicalInformation,
                    component: (
                        <Tab
                            title={ProfileTabs.TechnicalInformation}
                        >
                            <TechnicalInformation />
                        </Tab>
                    ),
                    roles: [
                        RoleName.MerchantAdmin,
                        RoleName.MerchantTech
                    ]
                }
            ])}
        />
    );
};

export default memo(Tabs);